/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Function } from './Function';
import {
    FunctionFromJSON,
    FunctionFromJSONTyped,
    FunctionToJSON,
} from './Function';

/**
 * 利用可能機能取得レスポンス
 * @export
 * @interface FunctionResult
 */
export interface FunctionResult {
    /**
     * ステータス
     * @type {string}
     * @memberof FunctionResult
     */
    status?: string;
    /**
     * メッセージ
     * @type {string}
     * @memberof FunctionResult
     */
    message?: string;
    /**
     * 利用可能機能一覧
     * @type {Array<Function>}
     * @memberof FunctionResult
     */
    functionList?: Array<Function>;
}

/**
 * Check if a given object implements the FunctionResult interface.
 */
export function instanceOfFunctionResult(value: object): value is FunctionResult {
    return true;
}

export function FunctionResultFromJSON(json: any): FunctionResult {
    return FunctionResultFromJSONTyped(json, false);
}

export function FunctionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'message': json['message'] == null ? undefined : json['message'],
        'functionList': json['functionList'] == null ? undefined : ((json['functionList'] as Array<any>).map(FunctionFromJSON)),
    };
}

export function FunctionResultToJSON(value?: FunctionResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'message': value['message'],
        'functionList': value['functionList'] == null ? undefined : ((value['functionList'] as Array<any>).map(FunctionToJSON)),
    };
}

